import React, { useState } from 'react';
import { TFunction } from 'i18next';
import { Attachment } from 'schema/Post/types';
import { PostAttachmentType } from '__generated__/graphql/legacy/graphql';
import ImagePreview from 'components/AttachmentPreview/ImagePreview';
import FilePreview from 'components/AttachmentPreview/FilePreview';
import AltTextModal from 'components/AltTextModal/AltTextModal';

interface AttachmentPreviewProps {
  attachment: Attachment;
  attachmentType: PostAttachmentType | null;
  t: TFunction;
  onAltTextChange: (altText: string) => void;
  onRemove: () => void;
}

const AttachmentPreview = ({
  attachment,
  attachmentType,
  t,
  onAltTextChange,
  onRemove,
}: AttachmentPreviewProps) => {
  const [showAltTextModal, setShowAltTextModal] = useState(false);

  if (!attachmentType) return null;

  const handleAltTextChange = (altText: string) => {
    onAltTextChange(altText);
    setShowAltTextModal(false);
  };

  const renderPreviews = () => {
    switch (attachmentType) {
      case 'image':
        return (
          <ImagePreview
            attachment={attachment}
            openAltTextModal={() => {
              setShowAltTextModal(true);
            }}
            t={t}
            onRemove={onRemove}
          />
        );
      case 'file':
        return (
          <FilePreview attachment={attachment} t={t} onRemove={onRemove} />
        );
      case 'video':
        return null;
      default:
        return null;
    }

    // Handle video preview or return null
    return null;
  };

  return (
    <>
      {renderPreviews()}

      {showAltTextModal && (
        <AltTextModal
          attachment={attachment}
          primaryColor="#007bff" // Use your theme color
          submitAltText={handleAltTextChange}
          t={t}
          onClose={() => setShowAltTextModal(false)}
        />
      )}
    </>
  );
};

export { AttachmentPreview };
